import { render } from "./ThemeBackground.vue?vue&type=template&id=4fda7202&scoped=true"
import script from "./ThemeBackground.vue?vue&type=script&lang=js"
export * from "./ThemeBackground.vue?vue&type=script&lang=js"

import "./ThemeBackground.vue?vue&type=style&index=0&id=4fda7202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fda7202"]])

export default __exports__